// 직업 설정(각인/추가특성/카운트)과 파생 상수만 보관
export const JOB_CONFIG = {
  _base: {
    commonTraits: [
      '피해 감소량', '받은 피해량',
      '카운터 성공 횟수', '배틀 아이템 사용 횟수',
      '무력화', '저스트 가드 성공 횟수',
    ],
    units: ['억', '만', '조', '%', '회'],
    mainCountDefault: 4,
    addCountDefault: 13,
  },
  '디스트로이어': {
    engravings: [
      { name: '분노의 망치', role: 'dealer' },
      { name: '중력 수련', role: 'dealer' },
    ],
    addTraits: ['방어력 감소 가동률', '방어력 감소 유효율', '중력 가중 및 해방 모드 가동률', '중력 가중 및 해방 모드 유효율'],
    mainCount: 4, addCount: 13,
  },
  '워로드': {
    engravings: [
      { name: '고독한 기사', role: 'dealer' },
      { name: '전투 태세', role: 'dealer' },
    ],
    addTraits: ['방향성 공격 증가 유효율', '방향성 공격 증가 가동률', '방어 태세 가동률', '방어 태세 유효율', '방어력 감소 가동률', '방어력 감소 유효율'],
    mainCount: 4, addCount: 15,
  },
  '버서커': {
    engravings: [
      { name: '광전사의 비기', role: 'dealer' },
      { name: '광기', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '폭주 가동률', '폭주 유효율'],
    mainCount: 4, addCount: 13,
  },
  '홀리나이트': {
    engravings: [
      { name: '심판자', role: 'dealer', addTraits: ['치명타 피해 증가 가동률', '치명타 피해 증가 유효율'], addCount: 11, },
      { name: '축복의 오라', role: 'supporter', addTraits: [], addCount: 15, }, // 추가
    ],
    addTraits: [],
    mainCount: 4,
  },
  '슬레이어': {
    engravings: [
      { name: '처단자', role: 'dealer' },
      { name: '포식자', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '폭주 가동률', '폭주 유효율'],
    mainCount: 4, addCount: 13,
  },
  '발키리': {
    engravings: [
      { name: '빛의 기사', role: 'dealer', addTraits: ['치명타 피해 증가 가동률', '치명타 피해 증가 유효율', '빛의 검 유효율'], addCount: 12, },
      { name: '해방자', role: 'supporter', addTraits: ['빛의 검 유효율'], addCount: 16 }, // 추가
    ],
    addTraits: [],
    mainCount: 4,
  },
  '배틀마스터': {
    engravings: [
      { name: '초심', role: 'dealer' },
      { name: '오의 강화', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 가동률', '치명타 저항 감소 유효율', '근원의 엘리멘탈 사용 횟수', '근원의 엘리멘탈 유효율'],
    mainCount: 4, addCount: 13,
  },
  '인파이터': {
    engravings: [
      { name: '극의: 체술', role: 'dealer' },
      { name: '충격 단련', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '투지발산 유효율'],
    mainCount: 4, addCount: 12,
  },
  '기공사': {
    engravings: [
      { name: '역천지체', role: 'dealer' },
      { name: '세맥타통', role: 'dealer' },
    ],
    addTraits: ['공격력 증가 가동률', '공격력 증가 유효율', '금강선공 1단계 가동률', '금강선공 1단계 유효율', '금강선공 2단계 가동률', '금강선공 2단계 유효율', '금강선공 3단계 가동률', '금강선공 3단계 유효율'],
    mainCount: 4, addCount: 17,
  },
  '창술사': {
    engravings: [
      { name: '절정', role: 'dealer' },
      { name: '절제', role: 'dealer' },
    ],
    addTraits: ['치명타 피해 증가 가동률', '치명타 피해 증가 유효율', '연가심공 사용 횟수', '연가심공 유효율'],
    mainCount: 4, addCount: 13,
  },
  '스트라이커': {
    engravings: [
      { name: '일격필살', role: 'dealer' },
      { name: '오의난무', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 가동률', '치명타 저항 감소 유효율', '구슬의 축복 사용 횟수', '구슬의 축복 유효율'],
    mainCount: 4, addCount: 13,
  },
  '브레이커': {
    engravings: [
      { name: '권왕파천무', role: 'dealer' },
      { name: '수라의 길', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '권왕태세 및 수라결 가동률', '권왕태세 및 수라결 유효율'],
    mainCount: 4, addCount: 13,
  },
  '데빌헌터': {
    engravings: [
      { name: '전술 탄환', role: 'dealer' },
      { name: '핸드거너', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 가동률', '치명타 저항 감소 유효율'],
    mainCount: 4, addCount: 11,
  },
  '블래스터': {
    engravings: [
      { name: '포격 강화', role: 'dealer' },
      { name: '화력 강화', role: 'dealer' },
    ],
    addTraits: ['방어력 감소 가동률', '방어력 감소 유효율'],
    mainCount: 4, addCount: 11,
  },
  '호크아이': {
    engravings: [
      { name: '두 번째 동료', role: 'dealer' },
      { name: '죽음의 습격', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율'],
    mainCount: 4, addCount: 11,
  },
  '스카우터': {
    engravings: [
      { name: '아르데타인의 기술', role: 'dealer' },
      { name: '진화의 유산', role: 'dealer' },
    ],
    addTraits: ['공격력 증가 가동률', '공격력 증가 유효율', '하이퍼 싱크 가동률', '하이퍼 싱크 유효율'],
    mainCount: 4, addCount: 13,
  },
  '건슬링어': {
    engravings: [
      { name: '평화주의자', role: 'dealer' },
      { name: '사냥의 시간', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 가동률', '치명타 저항 감소 유효율'],
    mainCount: 4, addCount: 11,
  },
  '바드': {
    engravings: [
      { name: '진실된 용맹', role: 'dealer', addTraits: ['방어력 감소 가동률', '방어력 감소 유효율'], addCount: 11 },
      { name: '절실한 구원', role: 'supporter', addTraits: [], addCount: 15 }, // 추가
    ],
    addTraits: [],
    mainCount: 4,
  },
  '서머너': {
    engravings: [
      { name: '넘치는 교감', role: 'dealer' },
      { name: '상급 소환사', role: 'dealer' },
    ],
    addTraits: ['방어력 감소 가동률', '방어력 감소 유효율', '아키르 폭주 가동률', '아키르 폭주 유효율'],
    mainCount: 4, addCount: 13,
  },
  '아르카나': {
    engravings: [
      { name: '황제의 칙령', role: 'dealer' },
      { name: '황후의 은총', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 가동률', '치명타 저항 감소 유효율', '카드 사용 횟수'],
    mainCount: 4, addCount: 12,
  },
  '소서리스': {
    engravings: [
      { name: '점화', role: 'dealer' },
      { name: '환류', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '마력 해방 가동률', '마력 해방 유효율'],
    mainCount: 4, addCount: 13,
  },
  '블레이드': {
    engravings: [
      { name: '잔재된 기운', role: 'dealer' },
      { name: '버스트 강화', role: 'dealer' },
    ],
    addTraits: ['방향성 공격 증가 가동률', '방향성 공격 증가 유효율', '버스트 강화 중첩 평균 소모량'],
    mainCount: 4, addCount: 12,
  },
  '데모닉': {
    engravings: [
      { name: '멈출 수 없는 충동', role: 'dealer' },
      { name: '완벽한 억제', role: 'dealer' },
    ],
    addTraits: ['피해 증가 가동률', '피해 증가 유효율', '악마화 가동률', '악마화 유효율'],
    mainCount: 4, addCount: 13,
  },
  '리퍼': {
    engravings: [
      { name: '달의 소리', role: 'dealer' },
      { name: '갈증', role: 'dealer' },
    ],
    addTraits: ['방어력 감소 가동률', '방어력 감소 유효율', '살인귀 가동률', '살인귀 유효율', '그림자 칼날 횟수', '그림자 칼날 유효율'],
    mainCount: 4, addCount: 15,
  },
  '소울이터': {
    engravings: [
      { name: '만월의 집행자', role: 'dealer' },
      { name: '그믐의 경계', role: 'dealer' },
    ],
    addTraits: ['피해 증가 유효율', '피해 증가 가동률', '사신화 및 영혼 강탈 횟수', '사신화 및 영혼 강탈 유효율'],
    mainCount: 4, addCount: 13,
  },
  '도화가': {
    engravings: [
      { name: '회귀', role: 'dealer', addTraits: ['방어력 감소 가동률', '방어력 감소 유효율', '수묵의 구슬 사용 횟수'], addCount: 12, },
      { name: '만개', role: 'supporter', addTraits: ['수묵의 구슬 사용 횟수'], addCount: 16, }, // 추가
    ],
    addTraits: [],
    mainCount: 4,
  },
  '기상술사': {
    engravings: [
      { name: '질풍노도', role: 'dealer' },
      { name: '이슬비', role: 'dealer' },
    ],
    addTraits: ['치명타 저항 감소 유효율', '여우비 유효율', '치명타 저항 감소 가동률', '여우비 가동률'],
    mainCount: 4, addCount: 13,
  },
  '환수사': {
    engravings: [
      { name: '야성', role: 'dealer' },
      { name: '환수 각성', role: 'dealer' },
    ],
    addTraits: ['방어력 감소 유효율', '방어력 감소 가동률', '환수 각성 가동률', '환수 각성 유효율'],
    mainCount: 4, addCount: 13,
  },
};

export const ROLE_COMMON_TRAITS = {
  dealer: [
    '피해량', '초당 피해량', '치명타 적중률',
    '1분 피해량', '1분 초당 피해량',
    '백어택 적중률', '헤드어택 적중률',
  ],
  supporter: [
    '조력피해량',
    '초당 조력 피해량',
    '1분 조력 피해량',
    '1분 초당 조력 피해량',
    '낙인 가동률',
    '낙인 유효율',
    '서포터 공격 증가 가동률',
    '서포터 공격 증가 유효율',
    '서포터 피해 증가 가동률 I',
    '서포터 피해 증가 유효율 I',
    '서포터 피해 증가 가동률 II',
    '서포터 피해 증가 유효율 II',
    '파티 회복량',
  ],
};

export const KNOWN_JOBS = Object.keys(JOB_CONFIG).filter(k => k !== '_base');
